import React from 'react';

import TextCardList from '../../../react4xp/components/TextCardList';
import Section from '../../../react4xp/components/Section'

function RichTextCards(props) {
	return (
		<Section>
			<TextCardList
				items={props.items}
			/>
		</Section>
	)
}

export default (props) => <RichTextCards {...props} />
